import store from '@/store'

export default (to, from, next) => {
  console.log('Guard routing to ', to)
  if (to.path === '/login') {
    next()
    return
  }
  console.log('checking anonymous...')
  // exit if we are allowing anonymous
  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next()
    return
  }
  console.log('checking login...')
  // exit if they are not authenticated
  if (!store.getters['authorize/token']) {
    store.dispatch('authorize/setPassthrough', to.path)
    console.log('going to login')
    next('/login')
    return
  }
  console.log('authorized')
  // exit if they are not allowed by role
  if (!store.getters['authorize/isAllowed'](to.path)) {
    console.log('not allowed...')
    next('/notauthorized')
    return
  }
  console.log('allowed, continuing...')
  // allowed
  next()
}



// WEBPACK FOOTER //
// ./src/router/guard-route.js